import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Grid,
  Grow,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { commonSort } from "../../common";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import moment from "moment";
import ls from "local-storage";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";

import {
  getTaskList,
  getStatusList,
  getAreaListAutonomous,
  getTechnicianList,
  getCostCenterList,
  downloadExcelFile,
  resetFilter,
} from "../../store/actions/AutonomousMaintenanceOrderTasksActions";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";
import FilterButton from "../../components/FilterButton/FilterButton";
import FilterDrawer from "../../components/FilterDrawer/FilterDrawer";
import DetailFilter from "../../components/DetailFilter/DetailFilter";
import CircularProgressBar from "../../components/ProgressBar/CircularProgressBar";

//set current date
const setCurrentDate = (date) => {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var modifiedMonth = month <= 9 ? "0" + month : month;
  var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var newStartDate = year + "-" + modifiedMonth + "-" + day;
  return newStartDate;
};

const GetFirstDayOfMonth = () => {
  var dt = new Date(); // current date of week
  return new Date(dt.getFullYear(), dt.getMonth(), 1);
};

const GetLastDayOfMonth = () => {
  var curr = new Date(); // get current date
  return new Date(curr.getFullYear(), curr.getMonth() + 1, 0);
};

const GetFirstDayOfWeek = (date) => {
  var day = date.getDay(),
    diff = date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
  return moment(date.setDate(diff));
};

//get last day of the week
const GetLastDayOfWeek = (date) => {
  var day = date.getDay(),
    diff = date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
  return moment(date.setDate(diff + 6));
};

const ss = sessionStorage;

function AutonomousMaintenanceOrderTask() {
  const { t } = useTranslation("translation");
  const initialState = {
    // default state
    status: ls.get("amotl_status") || [1, 2],
    user: ss.getItem("amotl_user") || 0,
    userName: ss.getItem("amotl_userName") || null,
    creatorName: ss.getItem("amotl_creatorName") || null,
    taskID: ss.getItem("amotl_taskID") || 0,
    technicianNote: ss.getItem("amotl_technicianNote") || null,
    maintenanceNote: ss.getItem("amotl_maintenanceNote") || null,
    planNote: ss.getItem("amotl_planNote") || null,
    startDate: ls.get("amotl_startDate") || GetFirstDayOfMonth(),
    endDate: ls.get("amotl_endDate") || GetLastDayOfMonth(),
    selectedCostCenter: ss.getItem("amotl_selectedCostCenter") || 0,
    selectedPlanId: ss.getItem("amotl_selectedMaintenanceOrderId") || 0,
    selectedAreaFilter: ss.getItem("amotl_selectedAreaFilter") || null,
    selectedAreaGroupId: ss.getItem("amotl_selectedAreaGroupId") || 0,
    selectedAssigneeId: ss.getItem("amotl_selectedAssigneeId") || 0,
    selectedCostCenterId: ss.getItem("amotl_selectedCostCenterId") || 0,
    selectedCreatorId: ss.getItem("amotl_creatorId") || 0,
  };

  const { AutonomousMaintenanceOrderTask } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [sortOrder, setSortOrder] = useState();
  const [sortColumn, setSortColumn] = useState();
  // pageSize
  const [rowsLength, setRowsLength] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [rows, setRows] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [selectedStatusName, setSelectedStatusName] = useState([]);
  const [areaData, setAreaData] = useState([]);
  //states
  const [state, setState] = useState({ ...initialState });
  const [excelFilterState, setExcelFilterState] = useState({});

  let history = useHistory();

  //pagination
  const HandleChangePage = (_event, newPage) => {
    loadDataHandler(newPage, rowsPerPage);
  };

  const HandleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    sessionStorage.setItem("amotl_rowsPerPage", event.target.value);
    loadDataHandler(0, event.target.value);
  };

  //dynamic sort function
  function HandleSort(row, column) {
    setSortOrder(commonSort(row, column)[0]);
    setSortColumn(commonSort(row, column)[1]);
    setRows(commonSort(row, column)[2]);
  }

  useEffect(() => {
    dispatch(getTechnicianList());
    dispatch(getCostCenterList());
    LoadHandler(0, rowsPerPage);
  }, []);

  useEffect(() => {
    if (AutonomousMaintenanceOrderTask.tasklist) {
      setRows(Object.values(AutonomousMaintenanceOrderTask.tasklist.content));
      setRowsLength(AutonomousMaintenanceOrderTask.tasklist.totalCount);
    }
  }, [AutonomousMaintenanceOrderTask.tasklist]);

  useEffect(() => {
    if (AutonomousMaintenanceOrderTask.statusList) {
      setStatusData(Object.values(AutonomousMaintenanceOrderTask.statusList));
      HandleStatusName(
        Object.values(AutonomousMaintenanceOrderTask.statusList),
        state.status
      );
      setPageLoaded(true);
    }
  }, [AutonomousMaintenanceOrderTask.statusList]);

  useEffect(() => {
    if (AutonomousMaintenanceOrderTask.areaList) {
      let areaList = AutonomousMaintenanceOrderTask.areaList;
      setAreaData(areaList);
    }
  }, [AutonomousMaintenanceOrderTask.areaList]);

  useEffect(() => {
    if (AutonomousMaintenanceOrderTask.technicianList) {
      setUserData(Object.values(AutonomousMaintenanceOrderTask.technicianList));
    }
  }, [AutonomousMaintenanceOrderTask.technicianList]);

  useEffect(() => {
    if (AutonomousMaintenanceOrderTask.costCenterList) {
      LoadAreaData();
      setCostCenterData(
        Object.values(AutonomousMaintenanceOrderTask.costCenterList)
      );
    }
  }, [AutonomousMaintenanceOrderTask.costCenterList]);

  let timeIntervals = [
    { id: 1, name: t("Today") },
    { id: 2, name: t("ThisWeek") },
    { id: 3, name: t("ThisMonth") },
    { id: 4, name: t("Manual") },
  ];

  const [selectedTimeInterval, setSelectedTimeInterval] = useState(
    ls.get("amotl_interval") || 3
  );

  const HandleTimeInterval = (e) => {
    setSelectedTimeInterval(e.target.value);
    ls.set("amotl_interval", e.target.value);
    HandleTimeSelection(e.target.value);
    loadDataHandler(0, rowsPerPage);
  };

  const SetDates = (start, end) => {
    setState({ ...state, startDate: start, endDate: end });
    ls.set("amotl_startDate", start);
    ls.set("amotl_endDate", end);
  };

  const HandleTimeSelection = (id) => {
    switch (id) {
      case 1: //gün
        SetDates(setCurrentDate(new Date()), setCurrentDate(new Date()));
        break;
      case 2: //hafta
        SetDates(GetFirstDayOfWeek(new Date()), GetLastDayOfWeek(new Date()));
        break;
      case 3: //ay
        SetDates(GetFirstDayOfMonth(), GetLastDayOfMonth());
        break;
      default:
        SetDates(setCurrentDate(new Date()), setCurrentDate(new Date()));
        break;
    }
  };

  const SetDefaultState = () => {
    setState((pS) => ({
      ...pS,
      status: ls.get("amotl_status") || [1, 2],
      user: 0,
      userName: null,
      creatorName: null,
      taskID: 0,
      technicianNote: null,
      maintenanceNote: null,
      planNote: null,
      startDate: GetFirstDayOfMonth(),
      endDate: GetLastDayOfMonth(),
      selectedCostCenter: null,
      selectedPlanId: 0,
      selectedAreaFilter: null,
      selectedAreaGroupId: 0,
      selectedAssigneeId: 0,
      selectedCostCenterId: 0,
      selectedCreatorId: 0,
    }));
  };

  function LoadHandler(pageNumber = page, pageSize = rowsPerPage) {
    if (ss.getItem("amotl_pushAutonomousMaintenanceDetail")) {
      setPage(parseInt(ss.getItem("amotl_pushAutonomousMaintenanceDetail")));
      loadDataHandler(
        parseInt(ss.getItem("amotl_pushAutonomousMaintenanceDetail")),
        pageSize
      );
      ss.removeItem("amotl_pushAutonomousMaintenanceDetail");
    } else {
      loadDataHandler(pageNumber, pageSize);
    }
    dispatch(getStatusList());
  }

  function loadDataHandler(
    pageNumber = page,
    pageSize = rowsPerPage,
    isFilterCleared = false
  ) {
    const data = {
      statusArr: ls.get("amotl_status")
        ? ls.get("amotl_status").toString()
        : "1, 2",
      assigneeId: ss.getItem("amotl_userId")
        ? parseInt(ss.getItem("amotl_userId"))
        : 0,
      creatorId: ss.getItem("amotl_creatorId")
        ? parseInt(ss.getItem("amotl_creatorId"))
        : 0,
      costCenterId: ss.getItem("amotl_costCenterId")
        ? parseInt(ss.getItem("amotl_costCenterId"))
        : 0,
      areaGroupId: ss.getItem("amotl_areaGroupId")
        ? parseInt(ss.getItem("amotl_areaGroupId"))
        : 0,
      taskNote: ss.getItem("amotl_planNote")
        ? ss.getItem("amotl_planNote")
        : null,
      orderNote: ss.getItem("amotl_maintenanceNote")
        ? ss.getItem("amotl_maintenanceNote")
        : null,
      orderId: ss.getItem("amotl_selectedMaintenanceOrderId")
        ? parseInt(ss.getItem("amotl_selectedMaintenanceOrderId"))
        : 0,
      taskID: ss.getItem("amotl_taskID")
        ? parseInt(ss.getItem("amotl_taskID"))
        : 0,
      machineId: isFilterCleared
        ? 0
        : machineStates.selectedSubEquipmentCode ??
          machineStates.selectedMainEquipmentCode ??
          0,
      startDate:
        ls.get("amotl_startDate") || GetFirstDayOfMonth().toISOString(),
      endDate: ls.get("amotl_endDate") || GetLastDayOfMonth().toISOString(),
      equipmentId: 0,
      pageNumber: isNaN(pageNumber) ? 1 : pageNumber + 1,
      pageSize: pageSize,
    };

    setExcelFilterState(data);
    dispatch(getTaskList(data));
    setPage(pageNumber);
  }

  //load area data for popup
  const LoadAreaData = () => {
    dispatch(getAreaListAutonomous());
  };

  //set status
  const HandleStatus = (event) => {
    setState({ ...state, status: event.target.value });
    HandleStatusName(statusData, event.target.value);
    ls.set("amotl_status", event.target.value);
  };

  //set status name
  const HandleStatusName = (rawArray, filterArray) => {
    const statusFiltered = rawArray.filter((el) => {
      return filterArray.some((f) => {
        return f === el.code;
      });
    });
    setSelectedStatusName(statusFiltered.map((item) => item.description));
  };

  //set assigned user
  const HandleUser = (userName) => {
    const userInfo = userData.filter((item) => item.userName == userName);
    let userId,
      userName1 = null;

    if (userInfo[0] != undefined) {
      //filter if user exist
      userId = userInfo[0].id;
      userName1 = userInfo[0].userName;
    }
    if (userName == null) {
      ss.removeItem("amotl_userName");
      ss.removeItem("amotl_userId");
    } else {
      ss.setItem("amotl_userName", userName1);
      ss.setItem("amotl_userId", userId);
    }
    setState({ ...state, user: userId, userName: userName1 });
  };

  //set start date
  const HandleStartDate = (date) => {
    setState({ ...state, startDate: setCurrentDate(date) });
    ls.set("amotl_startDate", setCurrentDate(date));
  };

  //set end date
  const HandleEndDate = (date) => {
    setState({ ...state, endDate: setCurrentDate(date) });
    ls.set("amotl_endDate", setCurrentDate(date));
  };

  const [userData, setUserData] = useState([]);
  const [costCenterData, setCostCenterData] = useState([]);

  const HandleApplyFilter = () => {
    loadDataHandler(0, rowsPerPage);
    dispatch(resetFilter());
  };

  const HandleClearFilter = () => {
    ss.clear();

    ls.set("amotl_status", []);
    ls.set("amotl_startDate", setCurrentDate(new Date()));
    ls.set("amotl_endDate", setCurrentDate(new Date()));
    ls.set("amotl_interval", 3);
    setSelectedTimeInterval(1);

    SetDefaultState();
    HandleClearMachineStates();
    loadDataHandler(0, rowsPerPage, true);
  };

  const initialMachineStates = (isCleared = false) => {
    return {
      ssAbr: "amotl",
      selectedAreaCode: isCleared
        ? null
        : ss.getItem("amotl_selectedAreaCode") ?? null,
      selectedAreaName: isCleared
        ? null
        : ss.getItem("amotl_selectedAreaName") ?? null,
      selectedMainEquipmentCode: isCleared
        ? null
        : ss.getItem("amotl_selectedMainEquipmentCode") ?? null,
      selectedMainEquipmentName: isCleared
        ? null
        : ss.getItem("amotl_selectedMainEquipmentName") ?? null,
      selectedSubEquipmentCode: isCleared
        ? null
        : ss.getItem("amotl_selectedSubEquipmentCode") ?? null,
      selectedSubEquipmentName: isCleared
        ? null
        : ss.getItem("amotl_selectedSubEquipmentName") ?? null,
    };
  };
  const [machineStates, setMachineStates] = useState(initialMachineStates);
  const HandleClearMachineStates = () => {
    ss.removeItem("amotl_selectedAreaCode");
    ss.removeItem("amotl_selectedAreaName");
    ss.removeItem("amotl_selectedMainEquipmentCode");
    ss.removeItem("amotl_selectedMainEquipmentName");
    ss.removeItem("amotl_selectedSubEquipmentCode");
    ss.removeItem("amotl_selectedSubEquipmentName");
    setMachineStates(initialMachineStates(true));
  };

  //set taskID state with taskNo area which comes from filter
  const FilterWithID = (e) => {
    if (e.target.value == null) {
      ss.setItem("amotl_taskID", 0);
      setState({ ...state, taskID: 0 });
    } else {
      ss.setItem("amotl_taskID", e.target.value);
      setState({ ...state, taskID: e.target.value });
    }
  };

  const FilterWithMaintenanceNote = (e) => {
    if (e.target.value == null) {
      ss.setItem("amotl_maintenanceNote", null);
      setState({ ...state, maintenanceNote: null });
    } else {
      ss.setItem("amotl_maintenanceNote", e.target.value);
      setState({ ...state, maintenanceNote: e.target.value });
    }
  };

  const FilterWithPlanNote = (e) => {
    if (e.target.value == null) {
      ss.setItem("amotl_planNote", null);
      setState({ ...state, planNote: null });
    } else {
      ss.setItem("amotl_planNote", e.target.value);
      setState({ ...state, planNote: e.target.value });
    }
  };

  const FilterPlanId = (e) => {
    if (e.target.value == null) {
      ss.setItem("amotl_selectedMaintenanceOrderId", 0);
      setState({ ...state, selectedPlanId: 0 });
    } else {
      ss.setItem("amotl_selectedMaintenanceOrderId", e.target.value);
      setState({ ...state, selectedPlanId: e.target.value });
    }
  };

  const HandleCostCenterChange = (costCenter) => {
    const costCenterInfo = costCenterData.filter(
      (item) => item.name === costCenter
    );
    let costCenterName = "";
    let costCenterId = 0;
    if (costCenterInfo[0] != undefined) {
      costCenterName = costCenterInfo[0].code;
      costCenterId = costCenterInfo[0].id;
    }
    if (costCenter == null) {
      ss.removeItem("amotl_costCenterName");
      ss.removeItem("amotl_costCenterId");
    } else {
      ss.setItem("amotl_costCenterName", costCenterName);
      ss.setItem("amotl_costCenterId", costCenterId);
    }
    setState({
      ...state,
      selectedCostCenter: costCenterName,
      selectedCostCenterId: costCenterId,
    });
  };

  // set creator for filter
  const HandleCreatorName = (creatorName) => {
    let creatorId,
      creatorName1 = null;
    const creatorInfo = userData.filter((item) => item.userName == creatorName);

    if (creatorInfo[0] != undefined) {
      creatorId = creatorInfo[0].id;
      creatorName1 = creatorName;
    }
    if (creatorName == null) {
      ss.removeItem("amotl_creatorName");
      ss.removeItem("amotl_creatorId");
    } else {
      ss.setItem("amotl_creatorName", creatorName1);
      ss.setItem("amotl_creatorId", creatorId);
    }
    setState({
      ...state,
      selectedCreatorId: creatorId,
      creatorName: creatorName1,
    });
  };

  const HandleAreaFilterChange = (areaName) => {
    const areaDataInfo = areaData.filter((item) => item.name == areaName);
    let areaDataName = null;
    let areaGroupId = null;
    if (areaDataInfo[0] != undefined) {
      areaDataName = areaDataInfo[0].name;
      areaGroupId = areaDataInfo[0].id;
    }
    if (areaName == null) {
      ss.removeItem("amotl_areaGroupName");
      ss.removeItem("amotl_areaGroupId");
    } else {
      ss.setItem("amotl_areaGroupName", areaDataName); //this state name changes from page to page and name must be unique
      ss.setItem("amotl_areaGroupId", areaGroupId);
    }
    setState({
      ...state,
      selectedAreaFilter: areaDataName,
      selectedAreaGroupId: areaGroupId,
    });
  };

  const NavigateToDetails = (id) => {
    ss.setItem("amotl_pushAutonomousMaintenanceDetail", page);
    history.push("/autonomous-maintenance-detail/?id=" + id);
  };

  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsFilterDrawerOpen(open);
  };

  const filter = () => {
    return (
      <DetailFilter
        HandleStatus={HandleStatus}
        statusData={statusData}
        status={state.status}
        selectedStatusName={selectedStatusName}
        HandleUser={HandleUser}
        userData={userData}
        userName={state.userName}
        HandleCreatorName={HandleCreatorName}
        creatorName={state.creatorName}
        HandleCostCenterChange={HandleCostCenterChange}
        isNotMultipleCostCenter={true}
        costCenterData={costCenterData}
        selectedCostCenterId={state.selectedCostCenterId}
        HandleAreaFilterChange={HandleAreaFilterChange}
        areaData={areaData}
        selectedAreaFilter={state.selectedAreaFilter}
        FilterWithID={FilterWithID}
        taskId={state.taskID}
        FilterPlanId={FilterPlanId}
        selectedPlanId={state.selectedPlanId}
        FilterWithMaintenanceNote={FilterWithPlanNote}
        maintenanceNote={state.planNote}
        FilterWithPlanNote={FilterWithMaintenanceNote}
        planNote={state.maintenanceNote}
        setMachineStates={setMachineStates}
        machineStates={machineStates}
        isAreaNotFiltered={true}
        HandleTimeInterval={HandleTimeInterval}
        timeIntervals={timeIntervals}
        selectedTimeInterval={selectedTimeInterval}
        HandleStartDate={HandleStartDate}
        startDate={state.startDate}
        HandleEndDate={HandleEndDate}
        endDate={state.endDate}
      />
    );
  };

  const responsiveTitle = () => {
    if (isMobile) {
      return <h4>{t("AutonomousMaintenanceOrderTaskList")}</h4>;
    } else {
      return <h1>{t("AutonomousMaintenanceOrderTaskList")}</h1>;
    }
  };

  return (
    <StyledTableDiv>
      {responsiveTitle()}
      {pageLoaded === true ? (
        <Grid id="amotl_Grid_1" container justifyContent="center">
          <FilterDrawer
            open={isFilterDrawerOpen}
            onOpen={toggleDrawer(true)}
            onClose={toggleDrawer(false)}
            HandleClearFilter={HandleClearFilter}
            HandleApplyFilter={() => {
              setIsFilterDrawerOpen(false);
              HandleApplyFilter();
            }}
            detailFilter={filter()}
            downloadExcel={() =>
              dispatch(
                downloadExcelFile({
                  ...excelFilterState,
                  startDate: excelFilterState.startDate ?? "2021-01-01",
                  endDate: excelFilterState.endDate ?? "2023-01-01",
                })
              )
            }
          />
          <FilterButton onClick={() => toggleDrawer(true)} />
        </Grid>
      ) : null}

      {rows.length > 0 ? (
        <Grow
          in={true}
          style={{ transformOrigin: "0 0 0" }}
          {...{ timeout: 1000 }}
        >
          <TableContainer component={Paper} style={{ marginTop: 20 }}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell
                    id="taskNo"
                    align="center"
                    onClick={() => HandleSort(rows, "id")}
                  >
                    {t("TaskNo")}{" "}
                    {sortColumn === "id" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                  <TableCell
                    id="completePercentage"
                    align="center"
                    onClick={() =>
                      HandleSort(rows, "checkItemCompletePercentage")
                    }
                  >
                    {t("CompletePercentage")}{" "}
                    {sortColumn === "checkItemCompletePercentage" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                  <TableCell
                    id="equipmentCode"
                    align="center"
                    onClick={() => HandleSort(rows, "equipmentDetailedCode")}
                  >
                    {t("EquipmentCode")}{" "}
                    {sortColumn === "equipmentDetailedCode" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                  <TableCell
                    id="equipmentName"
                    align="center"
                    onClick={() => HandleSort(rows, "equipmentName")}
                  >
                    {t("EquipmentName")}{" "}
                    {sortColumn === "equipmentName" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                  <TableCell
                    id="asisgned"
                    align="center"
                    onClick={() => HandleSort(rows, "assigneeName")}
                  >
                    {t("Assigned")}{" "}
                    {sortColumn === "assigneeName" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                  <TableCell
                    id="declarative"
                    align="center"
                    onClick={() => HandleSort(rows, "creatorName")}
                  >
                    {t("Declarative")}{" "}
                    {sortColumn === "creatorName" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                  <TableCell
                    id="maintenanceNote"
                    align="center"
                    onClick={() => HandleSort(rows, "orderNote")}
                  >
                    {t("MaintenanceNote")}{" "}
                    {sortColumn === "orderNote" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                  <TableCell
                    id="workingNote"
                    align="center"
                    onClick={() => HandleSort(rows, "notes")}
                  >
                    {t("WorkingNote")}{" "}
                    {sortColumn === "notes" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                  <TableCell
                    id="status"
                    align="center"
                    onClick={() => HandleSort(rows, "statusDesc")}
                  >
                    {t("Status")}{" "}
                    {sortColumn === "statusDesc" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                  <TableCell
                    id="maintenanceType"
                    align="center"
                    onClick={() => HandleSort(rows, "maintenanceTypeName")}
                  >
                    {t("MaintenanceType")}{" "}
                    {sortColumn === "maintenanceTypeName" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                  <TableCell
                    id="assignmentDuration"
                    align="center"
                    onClick={() => HandleSort(rows, "assigneeDurationMin")}
                  >
                    {t("AssignmentDuration")}{" "}
                    {sortColumn === "assigneeDurationMin" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                  <TableCell
                    id="startTime"
                    align="center"
                    onClick={() => HandleSort(rows, "startDurationMin")}
                  >
                    {t("StartTime")}{" "}
                    {sortColumn === "StartDurationMin" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                  <TableCell
                    id="totalTime"
                    align="center"
                    onClick={() => HandleSort(rows, "durationMin")}
                  >
                    {t("TotalTime")}{" "}
                    {sortColumn === "durationMin" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                  <TableCell
                    id="plannedDate"
                    align="center"
                    onClick={() => HandleSort(rows, "plannedDate")}
                  >
                    {t("PlannedDate")}{" "}
                    {sortColumn === "plannedDate" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                  <TableCell
                    id="startDate"
                    align="center"
                    onClick={() => HandleSort(rows, "startDate")}
                  >
                    {t("StartDate")}{" "}
                    {sortColumn === "startDate" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                  <TableCell
                    id="completionTime"
                    align="center"
                    onClick={() => HandleSort(rows, "completedDate")}
                  >
                    {t("CompletionTime")}{" "}
                    {sortColumn === "completedDate" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                  <TableCell
                    id="costCenter"
                    align="center"
                    onClick={() => HandleSort(rows, "costCenterCode")}
                  >
                    {t("CostCenter")}{" "}
                    {sortColumn === "costCenter" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                  <TableCell
                    id="planNo"
                    align="center"
                    onClick={() => HandleSort(rows, "maintenanceOrderId")}
                  >
                    {t("PlanNo")}{" "}
                    {sortColumn === "maintenanceOrderId" ? (
                      sortOrder === 1 ? (
                        <ArrowUpward />
                      ) : (
                        <ArrowDownward />
                      )
                    ) : null}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <TableRow
                    id={`amtlt_TableRow_2_${index}`}
                    onClick={() => NavigateToDetails(row.id)}
                    key={row.id}
                  >
                    <TableCell id="amtlt_TableCell_id" align="center">
                      {row.id}
                    </TableCell>
                    <TableCell
                      id="amtlt_TableCell_checkItemCompletePercentage"
                      align="center"
                    >
                      <CircularProgressBar
                        color="success"
                        value={row.checkItemCompletePercentage}
                      />
                    </TableCell>
                    <TableCell
                      id="amtlt_TableCell_equipmentDetailedCode"
                      align="center"
                    >
                      {row.equipmentDetailedCode}
                    </TableCell>
                    <TableCell
                      id="amtlt_TableCell_equipmentName"
                      align="center"
                    >
                      {row.equipmentName}
                    </TableCell>
                    <TableCell id="amtlt_TableCell_assigneeName" align="center">
                      {row.assigneeName}
                    </TableCell>
                    <TableCell id="amtlt_TableCell_creatorName" align="center">
                      {row.creatorName}
                    </TableCell>
                    <TableCell id="amtlt_TableCell_orderNote" align="center">
                      {row.orderNote}
                    </TableCell>
                    <TableCell id="amtlt_TableCell_notes" align="center">
                      {row.notes}
                    </TableCell>
                    <TableCell id="amtlt_TableCell_statusDesc" align="center">
                      {t(row.statusDesc)}
                    </TableCell>
                    <TableCell
                      id="amtlt_TableCell_maintenanceTypeName"
                      align="center"
                    >
                      {row.maintenanceTypeName}
                    </TableCell>
                    <TableCell
                      id="amtlt_TableCell_assigneeDurationMin"
                      align="center"
                    >
                      {row.hasOwnProperty("assigneeDurationMin") === false
                        ? "Field Missing"
                        : Math.round(row.assigneeDurationMin)}
                    </TableCell>
                    <TableCell
                      id="amtlt_TableCell_startDurationMin"
                      align="center"
                    >
                      {row.hasOwnProperty("startDurationMin") === false
                        ? "Field Missing"
                        : Math.round(row.startDurationMin)}
                    </TableCell>
                    <TableCell id="amtlt_TableCell_durationMin" align="center">
                      {Math.round(row.durationMin)}
                    </TableCell>
                    <TableCell id="amtlt_TableCell_plannedDate" align="center">
                      {row.plannedDate === "0001-01-01T00:00:00"
                        ? ""
                        : moment(row.plannedDate).format("DD.MM.YYYY HH:mm")}
                    </TableCell>
                    <TableCell id="amtlt_TableCell_startDate" align="center">
                      {row.hasOwnProperty("completedDate") === false
                        ? "Field Missing"
                        : "0001-01-01T00:00:00"
                        ? ""
                        : moment(row.startDate).format("DD.MM.YYYY HH:mm")}
                    </TableCell>
                    <TableCell
                      id="amtlt_TableCell_completedDate"
                      align="center"
                    >
                      {row.hasOwnProperty("startDate") === false
                        ? "Field Missing"
                        : row.completedDate === "0001-01-01T00:00:00"
                        ? ""
                        : moment(row.completedDate).format("DD.MM.YYYY HH:mm")}
                    </TableCell>
                    <TableCell
                      id="amtlt_TableCell_costCenterCode"
                      align="center"
                    >
                      {row.hasOwnProperty("costCenterCode") === false
                        ? "Field Missing"
                        : row.costCenterCode}
                    </TableCell>
                    <TableCell
                      id="amtlt_TableCell_maintenanceOrderId"
                      align="center"
                    >
                      {row.maintenanceOrderId}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[20, 50, 100]}
              component="div"
              count={rowsLength}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={HandleChangePage}
              onRowsPerPageChange={HandleChangeRowsPerPage}
            />
          </TableContainer>
        </Grow>
      ) : null}

      <LoadingBackdrop />
    </StyledTableDiv>
  );
}

export default withRouter(AutonomousMaintenanceOrderTask);
